import { Button } from '@ygoargentina/ui/components/custom/button';
import { Wrench } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

export default function MaintenanceError() {
  const navigate = useNavigate();

  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <Wrench className="h-20 w-20 text-muted-foreground mb-2" />
        <h1 className="text-[7rem] leading-tight font-bold">503</h1>
        <span className="font-medium text-lg">Estamos en mantenimiento</span>
        <p className="text-muted-foreground text-center">
          El sitio no esta disponible en este momento. <br />
          Volveremos en linea muy pronto.
        </p>
        <div className="mt-6 flex gap-4">
          <Button variant="outline" onClick={() => navigate({ to: '/' })}>
            Ir al inicio
          </Button>
        </div>
      </div>
    </div>
  );
}
